import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import classNames from 'classnames';
import { Field, FieldProps } from 'formik';
import React, { Component } from 'react';
import styles from './FormikCheckbox.module.scss';

type FormikCheckboxFieldProps<FieldValueType> = {
    name: string;
    label?: string;
    required?: boolean;
    disabled?: boolean;
    readOnly?: boolean;
    labelPlacement?: 'end' | 'start' | 'top' | 'bottom';
    convertValue?:(value: FieldValueType) => boolean;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
};

export class FormikCheckbox<FieldValueType = any> extends Component<FormikCheckboxFieldProps<FieldValueType>> {
    public render() {
        return <Field name={this.props.name} render={this.renderField} />;
    }

    private renderField = ({ field, form }: FieldProps) => {
        const { onChange, labelPlacement, convertValue, ...otherProps } = this.props;

        const handleChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
            if (otherProps.readOnly) return;

            form.setFieldTouched(field.name);
            form.setFieldValue(field.name, checked);

            if (onChange) onChange(event, checked);
        };

        const readOnlyOrDisabled = otherProps.readOnly || otherProps.disabled;

        const showNotAllowedCursor = classNames(
            {[styles.notAllowedCursor]: readOnlyOrDisabled},
            {[styles.force]: readOnlyOrDisabled}
        );

        const fieldValue = convertValue ? convertValue(field.value) : field.value;

        return (
            <FormControlLabel
                control={
                    <Checkbox
                        {...otherProps}
                        className={showNotAllowedCursor}
                        disabled={readOnlyOrDisabled}
                        checked={fieldValue || false}
                        onChange={handleChange}
                        data-test-id={`checkbox_${otherProps.name}`}
                    />
                }
                label={otherProps.label}
                labelPlacement={labelPlacement}
            />
        );
    };
}
